import { ExpenseEstimateDto, ExpenseTypeConst, ExpenseType } from '#modules/Budget/types/expense.types'
import i18next from 'i18next'


export const getExpenseEstimateTitle = (
	expenseEstimate: ExpenseEstimateDto,
): string => {
	const maintenanceExpenseTypes = [
		ExpenseTypeConst.CarMaintenanceCost,
		ExpenseTypeConst.HousingMaintenance,
	] as ExpenseType[]
	const carOperatingCostExpenses = [
		ExpenseTypeConst.Fuel,
		ExpenseTypeConst.VehicleElectricCharging,
	] as ExpenseType[]

	let title = maintenanceExpenseTypes.includes(expenseEstimate.type)
		? i18next.t('assetExpenses-budgetModal-maintenanceChain-label')
		: undefined
	title ??= carOperatingCostExpenses.includes(expenseEstimate.type)
		? i18next.t(`assetExpenses-budgetModal-${expenseEstimate.type}-label`)
		: undefined
	title ??= expenseEstimate.underlyingChain?.transactions[0]?.cleanedText
	title ??= i18next.t('assetExpenses-budgetModal-averageExpenses-label')

	return title
}
